import { Navigate, useLocation } from 'react-router';
import { LoadingOverlay } from '@mantine/core';

import type { JSX } from 'react';

export type PrivateRouteProps = {
  isAuth: boolean;
  isAccountLoading: boolean;
  children: JSX.Element;
};

export const PrivateRoute = ({ isAuth, children, isAccountLoading }: PrivateRouteProps) => {
  const location = useLocation();

  if (isAccountLoading) {
    return (
      <LoadingOverlay visible={true} zIndex={1000} overlayProps={{ radius: "sm", blur: 2 }} />
    );
  }

  return isAuth ? children : <Navigate to="/login" state={{ from: location }} />;
};
